<template>
    <div>
        <dx-text-box
            :value="value"
            cssClass="texbox-dictonary"
            :element-attr="{ class: 'class-name' }"
            :readOnly="true"
            :placeholder="placeholder"
            :buttons="buttonsOptions"
        />
        <div v-if="error" class="ai-dx-invalid" @click="emit('notifyErrorMessage')"></div>
        <dx-popup
            ref="popupRef"
            :drag-enabled="false"
            height="95%"
            :hide-on-outside-click="true"
            :show-close-button="true"
            :show-title="true"
            :title="title"
            :visible="popupVisible"
            @hidden="changePopupVisibility(false)"
            @shown="emit('popupShown')"
            @showing="emit('popupShowing')"
        >
            <slot />
        </dx-popup>
    </div>
</template>
<script>
export default {
    name: 'aiTextBoxDictionary',
};
</script>

<script setup>
import { onMounted, ref, reactive } from 'vue';
import { DxPopup, DxTextBox } from 'devextreme-vue';

const emit = defineEmits(['popupShown', 'notifyErrorMessage', 'popupHidden', 'popupShowing']);

const props = defineProps({
    value: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        default: '',
    },
    placeholder: {
        type: String,
        default: '',
    },
    customButtons: {
        type: Array,
        default: () => [],
    },
    error: {
        type: Object,
        default: () => {},
    },
    callbacks: {
        type: Object,
        default: () => ({
            dotsClick: () => {
                console.log('aiTextBoxDictionary, dotsClick');
            },
        }),
    },
});

const popupRef = ref(null);
const popupInstance = ref(null);

onMounted(() => {
    popupInstance.value = popupRef.value.instance;
});

const popupVisible = ref(false);

const changePopupVisibility = value => {
    popupVisible.value = value;
    if (value === false) emit('popupHidden');
};
const buttonsOptions = reactive([
    ...props.customButtons,
    {
        name: 'editButton',
        options: {
            icon: `<svg  width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path  d="M100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50C0 22.3858 22.3858 0 50 0C77.6142 0 100 22.3858 100 50Z" fill="#286EB6"/>
<path  d="M32.0012 50.0002C32.0012 53.314 29.3149 56.0002 26.0012 56.0002C22.6875 56.0002 20.0012 53.314 20.0012 50.0002C20.0012 46.6865 22.6875 44.0002 26.0012 44.0002C29.3149 44.0002 32.0012 46.6865 32.0012 50.0002Z" fill="white"/>
<path  d="M55.999 49.999C55.999 53.3127 53.3127 55.999 49.999 55.999C46.6853 55.999 43.999 53.3127 43.999 49.999C43.999 46.6853 46.6853 43.999 49.999 43.999C53.3127 43.999 55.999 46.6853 55.999 49.999Z" fill="white"/>
<path  d="M80.0005 49.999C80.0005 53.3127 77.3142 55.999 74.0005 55.999C70.6868 55.999 68.0005 53.3127 68.0005 49.999C68.0005 46.6853 70.6868 43.999 74.0005 43.999C77.3142 43.999 80.0005 46.6853 80.0005 49.999Z" fill="white"/>
</svg>
`,
            disabled: false,
            onClick: () => {
                changePopupVisibility(true);
                props.callbacks.dotsClick();
            },
        },
    },
]);

defineExpose({
    popupInstance,
    changePopupVisibility
});
</script>

<style lang="scss" scoped>
.class-name {
    :deep(.dx-texteditor-input) {
        color: black !important;
    }
}

:deep(.dx-textbox.dx-texteditor.class-name:not(.dx-state-hover)) {
    background-color: #D0E7FF;
}

:deep(.dx-textbox.dx-texteditor.class-name.dx-state-hover) {
    background-color: #AED6FF;
}

.ai-dx-invalid::after {
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 40%;
    margin-top: -11px;
    text-align: center;
    line-height: 23px;
    font-size: 14px;
    font-weight: 500;
    background-color: #ffffff00;
    color: #fff;
    content: '!';
    border-radius: 50%;
}

.ai-dx-invalid {
    cursor: pointer;
    position: absolute;
    top: 65%;
    right: 60px;
    margin-top: -11px;
    width: 22px;
    height: 22px;
    text-align: center;
    line-height: 23px;
    font-size: 14px;
    font-weight: 500;
    background-color: #f44336;
    color: #fff;
    content: '!';
    border-radius: 50%;
}
</style>
